export default "__VITE_ASSET__Dpbw7Mk$__"